import * as React from 'react'
import {compose} from 'redux'
import { Field, reduxForm} from 'redux-form'
import Grid from '@material-ui/core/Grid/Grid'
import {TextField} from 'redux-form-material-ui'
import autobind from 'autobind-decorator'
import {change, FormSection} from 'redux-form'
import {connect} from 'react-redux'
import { Validator } from 'src/core/form/Validator'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import Alert from 'src/shared/Alert/Alert'
import DateField from 'src/shared/form/DateField'
import { Typography, withStyles, Theme, createStyles, WithStyles } from '@material-ui/core'
import GeosuggestInput from 'src/shared/Autocomplete/GeosuggestInput'

const styles = (t:Theme) => createStyles({
  root: {
    marginTop: t.spacing.unit * 3
  },
  cnil: {
    margin: `${t.spacing.unit}px 0`,
    overflow: 'auto',
    padding: '.5rem',
    '& p': {
      fontSize: '12px',
      textAlign: 'justify'
    }
  }
});


interface IProps extends WithI18n,
  WithStyles<typeof styles>,
  ReturnType<typeof dispatch2props>
{
  handleSubmit: () => void;
  initialValues: any;
}

const validate = values => Validator.build(values, {
  phone: [Validator.required, Validator.customMobilePhone],
  main_phone: [Validator.customMobileFix],
  job: [Validator.required]
});

class ProfileEditionForm extends React.Component<IProps>{

  render(){
    const { handleSubmit, t, initialValues, classes } = this.props;
    return (
      <>
        <Alert type='warning'>
          {t.Profile_edit_alert}
        </Alert>
        <form style={{marginTop: 16}} onSubmit={handleSubmit}>
          <Grid container style={{marginTop: 16}}>
            <Grid item xs={12} md={4}>
              <Field
                name="birthday"
                component={DateField}
                label={t.Edit_profile_birthday}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <GeosuggestInput 
                  label={t.Edit_profile_birthplace}
                  placeholder={t.Edit_profile_birthplace}
                  value={initialValues.address.city}
                  onPlaceChanged={this.getAddress}
              />
            </Grid>
            <FormSection name="address">
                <Grid item xs={12} md={4}>
                    <Field
                        name="zip"
                        label={t.Edit_profile_birthCodePostal}
                        fullWidth={true}
                        className="test"
                        component={TextField}
                    />
                </Grid>
            </FormSection>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <Field
                name="phone"
                component={TextField}
                label={t.Edit_profile_mobile_phone}
                fullWidth={true}
              />
              <label style={{fontSize:'0.75rem', fontStyle: 'italic'}}>{t.Edit_profile_phone_description}</label>
            </Grid>
            <Grid item xs={6}>
              <Field
                name="main_phone"
                component={TextField}
                label={t.Edit_profile_pro_phone}
                fullWidth={true}
              />
            </Grid>
          </Grid>

          <div style={{display: 'none'}}>
            <Field
              name="birth_place"
              label={t.Edit_profile_address_city}
              fullWidth={true}
              component={TextField}
            />
          </div>
          
          <FormSection name="address">
            <Grid item xs={12} md={6}>
              <div style={{display: 'none'}}>
                <Field
                  name="city"
                  label={t.Edit_profile_address_city}
                  fullWidth={true}
                  component={TextField}
                />
                <Field
                  name="number"
                  label={t.Edit_profile_address_number}
                  fullWidth={true}
                  component={TextField}
                />
                <Field
                  name="street"
                  label={t.Edit_profile_birthplace}
                  fullWidth={true}
                  component={TextField}
                />
                <Field
                  name="country"
                  label={t.Edit_profile_birthplace}
                  fullWidth={true}
                  component={TextField}
                />
                <Field
                  name="zip"
                  label={t.Edit_profile_address_zip}
                  fullWidth={true}
                  component={TextField}
                  {...!(initialValues.address && initialValues.address.zip) && {variant:'filled'}}
                />
              </div>

            </Grid>
          </FormSection>
          <Grid container>
            <Grid item xs={12}>
              <Field
                name="job"
                component={TextField}
                label={t.Edit_profile_function}
                fullWidth={true}
              />
            </Grid>
          </Grid>
          <Grid container>
                <Grid item xs={12}>
                <div className={classes.cnil}>
                  <Typography variant="body2" gutterBottom>
                  <span style={{fontWeight: 'bold'}}>Données personnelles :</span> ‌les informations figurant ci-dessus sont obligatoires afin de bénéficier d’un accès personnalisé au portail de la Salle des Marchés du Groupe ARKEA. Ce portail vous permet d’accéder aux fonctionnalités d’enrichissement de connaissance client (KYC), signature électronique et génération de documents contractuels. Vous disposez sur ces données de droits dédiés comme notamment d’un droit d'accès, de rectification que vous pouvez exercer directement sur cette page. Pour toute assistance sur le sujet ou l’expression d’autres droits, comme un droit d’opposition, vous pouvez les exercer auprès du Back Office Clientèle - ARKEA, 1 rue Louis Lichou, 29480 Le Relecq-Kerhuon et/ou par e-mail 
                  <a href="mailto:back-office.clientele@arkea.com" style={{margin: '0 3px'}}>back-office.clientele@arkea.com</a>.
                  Si vous souhaitez des informations complémentaires sur l'ensemble de vos droits et plus largement sur la gestion de vos informations personnelles, vous pouvez vous reporter à la politique des données personnelles du présent portail.
                  </Typography>

                  <Typography variant="body2" gutterBottom>
                  Vous pouvez paramétrer sur ce portail vos acceptations ou refus de notification (par exemple vos abonnements aux notes d’informations économiques). Plus globalement, vos options d'acceptation ou de refus de prospection commerciale ont été collectées lors de votre entrée en relation avec votre chargé de compte. Si vous souhaitez les modifier, nous vous invitons à vous connecter sur votre espace privé de banque en ligne ou à contacter votre chargé de compte.
                  </Typography>
                  </div>
                </Grid>
          </Grid>
        </form>
      </>
    )
  }

  @autobind
  private getAddress(place){
    const { changeAddress } = this.props;
    changeAddress('birth_place', place.locality);
    changeAddress('address.city', place.locality);
    changeAddress('address.zip', place.postal_code);
    changeAddress('address.country', place.country);
    changeAddress('address.street', place.route);
    changeAddress('address.number', place.street_number);
  }
}

const dispatch2props = dispatch => ({
  changeAddress: (field, value) => dispatch(change('editProfileForm', field, value))
});

export default compose(
  withI18n,
  withStyles(styles),
  connect(null, dispatch2props)
)(reduxForm({
  form: 'editProfileForm',
  validate
})(ProfileEditionForm))



// WEBPACK FOOTER //
// ./src/page/Consumer/Profile/ProfileEditionForm.tsx